var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3332 15.75C21.2997 15.75 22.0832 14.9665 22.0832 14L22.0832 4C22.0832 3.0335 21.2997 2.25 20.3332 2.25L6.63671 2.25001C5.26022 2.25001 4.09576 3.26773 3.91147 4.63183L2.89632 12.1459C2.67339 13.796 3.95647 15.264 5.62156 15.264H8.64787C7.98013 16.3587 7.62007 17.3592 7.57369 18.2681C7.50761 19.563 8.08314 20.5679 9.04647 21.2581C9.73253 21.7496 10.5806 21.553 11.0878 21.0859L16.8814 15.75L20.3332 15.75ZM16.5832 13.9854L16.5832 3.75001L6.63671 3.75001C6.01104 3.75001 5.48174 4.21261 5.39797 4.83266L4.38282 12.3467C4.28148 13.0967 4.8647 13.764 5.62156 13.764H10.0739C10.3591 13.764 10.6196 13.9257 10.7461 14.1813C10.8726 14.4368 10.8432 14.742 10.6703 14.9688C9.54661 16.4426 9.11223 17.5511 9.07174 18.3446C9.03443 19.0755 9.32613 19.6132 9.92011 20.0388C9.92175 20.0401 9.92849 20.0455 9.95278 20.0425C9.98364 20.0387 10.0293 20.0215 10.0716 19.9825L16.5832 13.9854ZM18.0832 14.25H20.3332C20.4713 14.25 20.5832 14.1381 20.5832 14L20.5832 4C20.5832 3.86193 20.4713 3.75 20.3332 3.75L18.0832 3.75L18.0832 14.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/ThumbsDown.c2fe860861221edcae4799761fb12128.svg";
export { ForwardRef as ReactComponent };